// extracted by mini-css-extract-plugin
module.exports = {"marker":"MapMarker_marker__TTCDR"};